$(function () {
  'use strict';
  const $form = $('form[data-report-post-form]');
  if (!$form.length) return;

  let formSubmitting = false;

  $form.on('submit', function () {
    formSubmitting = true;
  });

  // 下書きを削除リンク（data-method="delete"）は submit を発火しないため個別に対応
  // remote: true がないためフルページナビゲーションになり ajax:success は発火しない
  // confirm:complete でユーザーが確認したタイミングでフラグをセットする
  // （フルページ遷移なので、リクエスト失敗時もページが遷移してJSステートがリセットされる）
  // confirm:complete は @rails/ujs が CustomEvent として発火するため、nativeのaddEventListenerで
  // e.detail[0]（確認結果）を参照する（jQueryの.on()ではdetailが第2引数に渡されない）
  document.addEventListener('confirm:complete', function (e) {
    if (!e.target.closest('a[data-method="delete"]')) return;
    if (e.detail[0]) {
      formSubmitting = true;
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      formSubmitting = false;
    }
  });

  window.addEventListener('beforeunload', function (e) {
    if (formSubmitting) return;

    e.preventDefault();
    // Chrome の bfcache を無効化して beforeunload を確実に発火させるために必要
    // NOSONAR
    e.returnValue = '';
  });
});
